var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnGround(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.5 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,9h10.5c.2,0,.4-.2.4-.4s-.2-.4-.4-.4H1.3c-.2,0-.4.2-.4.4s.2.4.4.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,4.7c0,.7-.8,1.2-1.8,1.2H2.1c-.4,0-.8-.1-.9-.4L0,3.2c0-.1,0-.2,0-.3h.2c.2-.2.3-.2.4,0l2,1.4h1.7c0-.1-1.7-3.3-1.7-3.3,0-.1,0-.3.1-.3h.4c.1,0,.3,0,.4.1l3.5,2.9c.2.2.3.2.5.2l3.1-.2c.9,0,1.8.3,1.8,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnGround);
export default __webpack_public_path__ + "static/media/on_ground.40be32f9e16612697adfa71dbe167fef.svg";
export { ForwardRef as ReactComponent };